module.exports = __webpack_public_path__ + "img/rural_qr.c1f6aa14.jpg";